export default [
  {
    url: "/dashboard/",
    name: "Dashboard",
    slug: "dashboard",
    icon: "HomeIcon",
    i18n: "Dashboard"
  },
  {
    url: "/trends",
    name: "View Trend Data",
    icon: "BarChart2Icon",
    i18n: "TrendData"
  },
  {
    url: "/dimmingPolicy",
    name: "Dimming Policy",
    icon: "SunriseIcon",
    i18n: "DimmingPolicy"
  },
  // {
  //   url: "/dimmingPolicy",
  //   name: "Schedule Policy",
  //   icon: "SunriseIcon",
  //   i18n: "SchedulePolicy"
  // },
  {
    url: "/modemMapView",
    name: "View SmartLinks",
    icon: "MapIcon",
    i18n: "ViewSmartLinks"
  },
  {
    url: "/masterView",
    name: "Master View",
    icon: "CompassIcon",
    i18n: "MasterView"
  },
  {
    url: "/surveillux",
    name: "Surveillux",
    icon: "VideoIcon",
    i18n: "Surveillux"
  },
  {
    header: "Utilities Management",
    i18n: "UtilitiesManagement"
  },
  {
    url: "/zones",
    name: "Zone Management",
    icon: "CrosshairIcon",
    i18n: "Zones"
  },
  {
    url: "/locations",
    name: "Location Management",
    icon: "MapPinIcon",
    i18n: "Locations"
  },
  {
    url: "/modems",
    name: "SmartLink Management",
    icon: "CpuIcon",
    i18n: "SmartLinks"
  },
  {
    header: "User",
    i18n: "User"
  },
  {
    name: "User Profile",
    url: "/profile",
    icon: "UserIcon",
    i18n: "UserProfile"
  }
  // {
  //   url: null,
  //   name: "Modem Reports",
  //   icon: "TrelloIcon",
  //   i18n: "ModemReports",
  //   submenu: [
  //     {
  //       url: "/modemReports/modemStatus",
  //       name: "Modem Status",
  //       slug: "ModemStatus",
  //       i18n: "ModemStatus"
  //     }
  //   ]
  // },
  // {
  //   header: "Monitoring",
  //   i18n: "Monitoring"
  // },
  // {
  //   url: "/monirtoring/dataMonitoring",
  //   name: "Data Monitoring",
  //   icon: "HardDriveIcon",
  //   i18n: "DataMonitoring"
  // },
  // {
  //   url: "/monirtoring/faultMonitoring",
  //   name: "Fault Monitoring",
  //   icon: "ZapOffIcon",
  //   i18n: "FaultMonitoring"
  // }
];
